/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/upperCaseFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoResizer implements angular.IDirective {
        private window: angular.IWindowService;
        restrict = "A";
        
        constructor($window: ng.IWindowService) {
            this.window = $window;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var window = this.window;
            let retValue: number = window.navigator.userAgent.indexOf('Macintosh');
            scope.deviceParams = [];

            const onResize = () =>
            {
                scope.$apply(()=> {
                    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                    scope.deviceParams.isMobileDevice = scope.isMobileDevice = vw < 600;
                    scope.deviceParams.isIpad = scope.isIpad = device.ipad();
                    scope.deviceParams.isIphone = scope.isIphone = device.iphone();
                    scope.deviceParams.isLargeTablet = scope.isLargeTablet = device.largeTablet();
                });
            };

            const onOrientationChange = () => {
                () =>
                {
                    window.setTimeout(() => {
                        scope.$apply(()=> {
                            scope.deviceParams.isPortrait = scope.isPortrait = device.portrait();
                        });
                    }, 1000);
                }
            };

            scope.$on('$destroy', () => {
                angular.element(window).off('resize', onResize);
                angular.element(window).off('orientationchange', onOrientationChange);
            });

            angular.element(window).on('resize', onResize);
            angular.element(window).on('orientationchange', onOrientationChange); 
         
            scope.deviceParams.isMobileDevice = scope.isMobileDevice = device.mobile();
            scope.deviceParams.isAndroidDevice = scope.isAndroidDevice = device.android();
            scope.deviceParams.isIpad = scope.isIpad = device.ipad();
            scope.deviceParams.isIphone = scope.isIphone = device.iphone();
            scope.deviceParams.isLargeTablet = scope.isLargeTablet = device.largeTablet();
            scope.deviceParams.isPortrait = scope.isPortrait = device.portrait();
            scope.deviceParams.isMacintosh = scope.isMacintosh = ((retValue != -1) ? true : false);
            scope.deviceParams.isDesktop = scope.isDesktop = device.desktop();
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($window) => {
                return new MeevoResizer($window);
            };

            directive.$inject = ["$window"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoResizer", MeevoResizer.factory());
}